export default __webpack_public_path__ + "static/media/GothamSSm-Bold.fe52d71e.eot";